import React, { useContext } from 'react';
import { makeId } from '../../../utilities/idComponent';
import { Button, ButtonProps } from '../Button';

import { Colors } from '@oy/uicore';
import { IconName, SystemIcon } from '@oy/uiicon';
import { Spacer } from '../../Layout';
import { DropdownContext } from './DropdownContext';

export type DropdownButtonWithIconProps = {
  timeout?: number;
  iconName: IconName;
} & ButtonProps;

const ICON_COLORS = {
  [Button.Color.Primary]: Colors.BLUE100,
  [Button.Color.Secondary]: Colors.BLACK100,
  [Button.Color.Destructive]: Colors.RED100,
};

const ICON_SIZES = {
  [Button.Size.Small]: 16,
  [Button.Size.Medium]: 20,
  [Button.Size.Large]: 24,
};

// @deprecated Don't use this component
const DropdownButtonWithIcon = ({
  children,
  iconName,
  id,
  timeout = 500,
  buttonType = Button.Type.Filled,
  color = Button.Color.Primary,
  size = Button.Size.Medium,
  ...props
}: DropdownButtonWithIconProps) => {
  const iconColor =
    buttonType === Button.Type.Filled
      ? Colors.WHITE
      : ICON_COLORS[color as keyof typeof ICON_COLORS];

  const iconSize = ICON_SIZES[size];

  const childrenSpacer =
    size === Button.Size.Large ? Spacer.Size.S : Spacer.Size.XS;

  const { buttonRef, onToggle, hideMenu } = useContext(DropdownContext);

  const onBlur = () => {
    setTimeout(hideMenu, timeout);
  };

  return (
    <Button
      {...props}
      id={makeId('list', undefined, id)}
      ref={buttonRef}
      onBlur={onBlur}
      onClick={onToggle}
      buttonType={buttonType}
      color={color}
      size={size}
    >
      {children && <Spacer right={childrenSpacer}>{children}</Spacer>}
      <SystemIcon color={iconColor} name={iconName} size={iconSize} />
    </Button>
  );
};

export default DropdownButtonWithIcon;
